import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'vehicle'],

    data() {
        return {
            title: '',
            buttonTitle: '',
            isLoading: false,
            selectedVehicle: null,
            name: '',
            plate: '',
            description: '',
            registrationExpiration: '',
            visibleEditFields: false,
            hasError: '',
            kilometersTraveled: 0,
            averageSpending: 0.0,
            smallService: 0,
            lastSmallService: 0,
            fuel: 'GASOLINE',
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                if(this.vehicle == null){
                    this.selectedVehicle = null;
                    this.title = "Dodaj vozilo"
                    this.buttonTitle = "Dodaj"
                    this.visibleEditFields = false;
                }else{
                    this.selectedVehicle = this.vehicle;
                    this.title = "Izmeni vozilo"
                    this.buttonTitle = "Izmeni"
                    this.name = this.vehicle.name;
                    this.plate = this.vehicle.registrationPlate;
                    this.description = this.vehicle.description;
                    this.visibleEditFields = true;
                    this.registrationExpiration = this.vehicle.registrationExpiration;
                    this.kilometersTraveled = this.vehicle.kilometersTraveled != null ? this.vehicle.kilometersTraveled : 0;
                    this.averageSpending = this.vehicle.averageSpending != null ? this.vehicle.averageSpending : 0;
                    this.smallService = this.vehicle.smallService != null ? this.vehicle.smallService : 0;
                    this.lastSmallService = this.vehicle.lastSmallService != null ? this.vehicle.lastSmallService : 0;
                    this.fuel = this.vehicle.fuel != null ? this.vehicle.fuel : '';
                    console.log(this.vehicle.fuel)
                }
            }
        },
        name: function(val, oldVal) {
            this.hasError = '';
        },
        plate: function(val, oldVal) {
            this.hasError = '';
        },
        description: function(val, oldVal) {
            this.hasError = '';
        },
        registrationExpiration: function(val, oldVal) {
            this.hasError = '';
        }
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeAddVehicle')
        },
        successUpdate(){
            this.$topnavbar.$emit('successAddVehicle')
        },

        successEdit(){
            this.$topnavbar.$emit('successEditVehicle')
        },

        addVehicle: addVehicle,
        isAdmin: isAdmin,
        editVehicle: editVehicle,
        reset: reset,
    }
}

function addVehicle() {
    if(this.name.length === 0 ||
        this.plate.length === 0 || this.kilometersTraveled === 0 ||
        this.averageSpending === 0 || this.smallService === 0 || this.lastSmallService === 0 || this.fuel === '') {
        this.hasError = "Molimo popunite ime i tablicu, predjene KM, mali servis, prosečnu potrošnju, tip goriva";
        return;
    }

    if(this.vehicle != null){
        this.editVehicle();
        return;
    }
    let _self = this;
    const newModel = {
        name: _self.name,
        registrationPlate: _self.plate,
        description: _self.description,
        registrationExpiration: _self.registrationExpiration == null || _self.registrationExpiration.length === 0 ? null : _self.registrationExpiration,
        kilometersTraveled: _self.kilometersTraveled,
        averageSpending: _self.averageSpending,
        smallService: _self.smallService,
        lastSmallService: _self.lastSmallService,
        fuel: _self.fuel,
    };
    _self.isLoading = true;
    AdminApiService.createVehicle(newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}

function editVehicle() {
    let _self = this;
    const newModel = {
        name: _self.name,
        registrationPlate: _self.plate,
        description: _self.description,
        registrationExpiration:  _self.registrationExpiration == null || _self.registrationExpiration.trim().length === 0 ? null : _self.registrationExpiration,
        kilometersTraveled: _self.kilometersTraveled,
        averageSpending: _self.averageSpending,
        smallService: _self.smallService,
        lastSmallService: _self.lastSmallService,
        fuel: _self.fuel,
    };
    _self.isLoading = true;
    AdminApiService.editVehicle(newModel, _self.vehicle.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successEdit();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom izmene vozila."
        })
}

function reset() {
    this.name = '';
    this.plate = '';
    this.description = '';
    this.registrationExpiration = '';
    this.kilometersTraveled = 0;
    this.averageSpending = 0;
    this.smallService = 0;
    this.lastSmallService = 0;
    this.fuel = 'GASOLINE';

}

function isAdmin() {
    return session.getRole() === 'ADMIN'
}



// WEBPACK FOOTER //
// ./src/modals/AddVehicleModal.js